import { createSelector } from 'reselect';
import { serviceProviderUsers, serviceProviderLocations } from './serviceProviderSelectors.js';

const stableObject = {};
const stableArray = [];

export const mobile = (state) => state.ui.mobile === true;

export const filters = (state) => state.ui.filters;
export const search = (state) => state.ui.filters.search;
export const filteredUserId = (state) => state.ui.filters.userId;
export const dateRangePickerSelector = (state) => state.ui.filters.datePicker;
export const filteredUser = createSelector(filteredUserId, serviceProviderUsers, (userId, users) => (users || stableArray).find((user) => user.id === userId));
export const filteredLocationId = (state) => state.ui.filters.locationId;
export const filteredLocation = createSelector(filteredLocationId, serviceProviderLocations, (locationId, locations) => (locations || stableArray).find((location) => location.id === locationId));
export const boundFormStateById = (id) => (state) => (state.ui.boundForms[id] || stableObject).state || stableObject;
